import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TESTIMONIALS } from "@/data/content";
import { COACHING_STORIES } from "@/data/coaching";
import { fadeUp, staggered } from "@/lib/motion";

const featured = TESTIMONIALS[0];
const total = TESTIMONIALS.length + COACHING_STORIES.length;

export const StoriesTeaser = () => (
  <section data-testid="stories-teaser-section" className="bg-snow py-14 sm:py-20">
    <div className="mx-auto grid items-center gap-10 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
      <motion.div {...fadeUp}>
        <h2 className="font-heading text-3xl font-bold tracking-tight text-ink sm:text-4xl">Don't Take Our Word for It</h2>
        <p className="mt-4 font-heading text-lg font-semibold text-navy sm:text-xl">{total} leaders have shared their PKR story.</p>
        <Button asChild data-testid="teaser-client-stories-link" className="btn-primary mt-8 h-12 px-6 text-base">
          <Link to="/client-stories">Read the client stories <ArrowRight className="ml-2 h-4 w-4" /></Link>
        </Button>
      </motion.div>
      <motion.figure
        {...staggered(fadeUp, 1, 0.1)}
        className="border border-navy/10 bg-white p-8 sm:p-10"
      >
        <Quote className="h-8 w-8 text-navy" fill="currentColor" strokeWidth={0} />
        <blockquote className="mt-4 font-heading text-lg font-medium leading-relaxed text-ink sm:text-xl">{featured.quote}</blockquote>
        <figcaption className="mt-6 flex items-center gap-4">
          <img src={featured.photo} alt={featured.name} className="h-12 w-12 object-cover" />
          <div>
            <p className="font-semibold text-ink">{featured.name}</p>
            <p className="text-sm text-ink/60">{featured.title}</p>
          </div>
        </figcaption>
      </motion.figure>
    </div>
  </section>
);
